import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { NAV, CONTACT, LOGO } from "@/data/content";

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "backdrop-blur-xl bg-bone/80 border-b border-border/60" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8 flex items-center justify-between h-20">
        <Link to="/" data-testid="logo-link" className="flex items-center">
          <img src={LOGO.light} alt="Lighthouse Home Services" className="h-14 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors duration-200 hover:text-navy ${
                  isActive ? "text-navy" : "text-muted-foreground"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/contact"
            data-testid="nav-quote-btn"
            className="hidden md:inline-flex items-center rounded-full bg-navy px-6 py-3 text-sm font-semibold text-white transition-colors duration-300 hover:bg-navy/85"
          >
            Request a Quote
          </Link>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((o) => !o)}
            className="lg:hidden grid place-items-center h-11 w-11 rounded-full border border-border text-navy"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-bone border-b border-border px-5 pb-8 pt-2">
          <div className="flex flex-col">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                className={({ isActive }) =>
                  `py-3 text-lg font-serif border-b border-border/60 ${isActive ? "text-navy" : "text-muted-foreground"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <a href={CONTACT.phoneHref} className="mt-5 inline-flex items-center gap-2 rounded-full bg-navy px-6 py-3 text-sm font-semibold text-white justify-center">
              <Phone className="h-4 w-4" /> {CONTACT.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
